<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list" v-show="editMode">
          {{ this.parentRoute.menuName }}-申请转科
        </span>
        <span class="list" v-show="!editMode">
          {{ this.parentRoute.menuName }}-{{ title }}申请转科
        </span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">转科基础信息</span>
          </div>

          <el-row>
            <el-col :span="6">
              <el-form-item label="转科单号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成报修单号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建日期" prop="createdTime">
                <el-date-picker disabled v-model="form.createdTime" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="系统默认为当前日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="原使用科室" prop="oldDeptName">
                <el-select :disabled="!editMode" v-model="form.oldDeptName" style="width: 90%" filterable placeholder="请选择原使用科室" :filter-method="getDepts" @change="oldDeptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="原科室使用人" prop="oldUserName">
                <el-select :disabled="!editMode" v-model="form.oldUserName" style="width: 90%" filterable placeholder="请选择原科室使用人" :filter-method="getOldDeptUsers" @change="oldUserChange">
                  <el-option v-for="item in oldDeptUsers" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="原科室保管人" prop="custodianName">
                <el-select :disabled="!editMode" v-model="form.custodianName" style="width: 90%" filterable placeholder="请选择原科室保管人" :filter-method="getCustodianUsers" @change="custodianChange">
                  <el-option v-for="item in custodianUsers" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="新使用科室" prop="newDeptName">
                <el-select :disabled="!editMode" v-model="form.newDeptName" style="width: 90%" filterable placeholder="请选择新使用科室" :filter-method="getDepts" @change="newDeptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id" :disabled="form.oldDeptId == item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="新科室使用人" prop="newUserName">
                <el-select :disabled="!editMode" v-model="form.newUserName" style="width: 90%" filterable placeholder="请选择新科室使用人" :filter-method="getNewDeptUsers" @change="newUserChange">
                  <el-option v-for="item in newDeptUsers" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="新科室保管人" prop="newCustodianName">
                <el-select :disabled="!editMode" v-model="form.newCustodianName" style="width: 90%" filterable placeholder="请选择新科室保管人" :filter-method="getnewCustodianUsers" @change="newCustodianChange">
                  <el-option v-for="item in newCustodianUsers" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="存放地点" prop="address">
                <el-input v-model="form.address" :disabled="!editMode" style="width: 90%" placeholder="请填写存放地点"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="转科日期" prop="date">
                <el-date-picker :disabled="!editMode" v-model="form.date" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择转科日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总数量" prop="totalNumber">
                <el-input disabled v-model="form.totalNumber" placeholder="根据详细信息数量求和汇总" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总金额" prop="totalAmount">
                <el-input disabled v-model="form.totalAmount" placeholder="根据详细信息金额求和汇总" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="转科原因" prop="reason">
                <el-input :disabled="!editMode" v-model="form.reason" placeholder="请填写转科原因" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="edit-card" style="margin-top: 20px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">转科详细信息</span>
          </div>
          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column show-overflow-tooltip type="selection" fixed width="50" align="center" />
            <el-table-column show-overflow-tooltip label="资产编号" align="center" min-width="140" prop="fixedAssetNo" />
            <el-table-column show-overflow-tooltip label="资产名称" align="center" min-width="130" prop="fixedAssetName" />
            <el-table-column label="资产卡号" align="center" min-width="200" prop="fixedAssetCards">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="bottom" popper-class="tooltip-content">
                  <div slot="content" class="">
                    <div class="tooltip-text" v-for="item in scope.row.assetCardInfos" :key="item.id">
                      {{ item.no }}
                    </div>
                  </div>
                  <span class="td-overflow-hidden">{{
                    scope.row.assetCardInfos
                      ? scope.row.assetCardInfos.map((e) => e.no).join(";")
                      : ""
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="规格型号" align="center" min-width="130" prop="specName" />
            <!-- <el-table-column show-overflow-tooltip label="单位" align="center" min-width="80" prop="unitName" /> -->
            <el-table-column show-overflow-tooltip label="单位" align="center" min-width="80" prop="unitName" />
            <!-- <el-table-column show-overflow-tooltip label="品牌" align="center" min-width="100" prop="brandName" /> -->
            <el-table-column show-overflow-tooltip label="生产厂家" align="center" min-width="130" prop="manufacturerName" />
            <el-table-column show-overflow-tooltip label="供应商" align="center" min-width="130" prop="supplierName" />
            <el-table-column show-overflow-tooltip label="资产类型" align="center" min-width="130" prop="assetTypeName" />
            <el-table-column show-overflow-tooltip label="产地类型" align="center" min-width="80" prop="productionPlaceName" />
            <el-table-column show-overflow-tooltip label="财务分类" align="center" min-width="80" prop="financeTypeName" />
            <el-table-column show-overflow-tooltip label="转科数量" align="center" min-width="80" prop="number" />
            <el-table-column show-overflow-tooltip label="单价" align="center" min-width="80" prop="price" />
            <el-table-column show-overflow-tooltip label="金额" align="center" min-width="80" prop="amount" />
          </el-table>
        </div>
        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
      <el-dialog title="资产信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row>
            <el-col :span="6">
              <el-form-item label="资产编号" prop="fixedAssetNo">
                <SelectTable :disabled="!editMode" :columns="stockColumns" :placeholder="'请选择资产编号'" :innerName="childForm.fixedAssetNo" :dataList="STATIC_Stocks" @filterMethod="getFixedAssetList" @change="selectAsset" style="width: 100%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产名称" prop="fixedAssetName">
                <el-input disabled v-model="childForm.fixedAssetName" placeholder="请填写资产名称" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产卡号" prop="assetCardIdArr">
                <el-select :disabled="!editMode" v-model="childForm.assetCardIdArr" placeholder="请选择资产卡号" multiple collapse-tags :filter-method="getAssetCards" @change="cardChange" style="width: 100%">
                  <el-option v-for="item in STATIC_AssetCards" :key="item.id" :label="item.no" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="规格型号" prop="specName">
                <el-input disabled v-model="childForm.specName" placeholder="系统自动带出规格型号" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="单位" prop="unitName">
                <el-input disabled v-model="childForm.unitName" placeholder="系统自动带出单位" />
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="品牌" prop="brandName">
                <el-input disabled v-model="childForm.brandName" placeholder="系统自动带出品牌" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产类型" prop="assetTypeName">
                <el-input disabled v-model="childForm.assetTypeName" placeholder="系统自动带出资产类型" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="数量" prop="number">
                <el-input-number :key="'num' + childForm.maxNum" disabled v-model="childForm.number" :min="childForm.maxNum" :precision="2" :controls="false" placeholder="请填写数量" @change="childNumberChange" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单价" prop="price">
                <el-input disabled v-model="childForm.price" placeholder="请填写单价" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="金额" prop="amount">
                <el-input disabled v-model="childForm.amount" placeholder="请填写单价" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="货位" prop="location">
                <el-input disabled v-model="childForm.location" placeholder="系统自动带出货位" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产地类型" prop="productionPlaceName">
                <el-input disabled v-model="childForm.productionPlaceName" placeholder="系统自动带出产地类型" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产厂家" prop="manufacturerName">
                <el-input disabled v-model="childForm.manufacturerName" placeholder="系统自动带出生产厂家" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="供应商" prop="supplierName">
                <el-input disabled v-model="childForm.supplierName" placeholder="系统自动带出供应商" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// import { config } from "@/utils/config";
import GetDataMixin from "@/mixin/getData-mixin.js";
import { MaintenanceDimensionOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import {
  GetDictionarys,
  GetDeptAssetTransferById,
  SaveDeptAssetTransfer,
  RejectDeptAssetTransfer,
} from "@/api";
export default {
  mixins: [GetDataMixin],
  components: { SelectTable, ApproveInfo },
  /** 定义属性 */
  data () {
    return {
      editMode: false,
      form: {},
      rules: {
        oldDeptName: [
          { required: true, message: "原使用科室不能为空", trigger: "blur" },
        ],
        oldUserName: [
          { required: true, message: "原科室使用人不能为空", trigger: "blur" },
        ],
        newDeptName: [
          { required: true, message: "新使用科室不能为空", trigger: "blur" },
        ],
        newUserName: [
          { required: true, message: "新科室使用人不能为空", trigger: "blur" },
        ],
        date: [
          { required: true, message: "转科日期不能为空", trigger: "blur" },
        ],
        reason: [
          { required: true, message: "转科原因不能为空", trigger: "blur" },
        ],
      },
      MaintenanceDimensionOptions: MaintenanceDimensionOptions,
      // 子表
      childForm: {},
      childFormRules: {
        fixedAssetNo: [
          { required: true, message: "资产编号不能为空", trigger: "blur" },
        ],
        number: [{ required: true, message: "数量不能为空", trigger: "blur" }],
        assetCardIdArr: [
          { required: true, message: "资产卡号不能为空", trigger: "blur" },
        ],
      },
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      openSubformModal: false,
      editChildren: false,

      oldDeptUsers: [],
      custodianUsers: [],
      newDeptUsers: [],
      newCustodianUsers: [],
      reject: RejectDeptAssetTransfer,
      url: "/673779283786313728?token=null&ids=",
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    InitData () {
      var query = this.$route.query;
      if (query.id) {
        this.handleUpdate(query.id);
      } else {
        this.handleAdd();
      }
      this.getDepts("");
      this.getFixedAssetList("");
      this.getAssetCards();
      this.getManufacturers();
    },
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetDeptAssetTransferById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;

        this.initWorkFlowProperty(this.form);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
      });
    },
    /**
     * 初始化表单
     */
    resetForm () {
      this.form = {
        createdUserName: this.userInfo.name,
        createdTime: this.parseTime(new Date(), "{y}-{m}-{d}"),
        oldDeptId: "",
        oldDeptName: "",
        newDeptId: "",
        newDeptName: "",
        address: "",
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        totalNumber: null,
        totalAmount: null,
        details: [],
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        assetId: "",
        fixedAssetNo: "",
        fixedAssetName: "",
        specName: "",
        assetCardIds: "",
        assetCardIdArr: [],
        assetCardInfos: [],
        maxNum: 0,
        supplierId: "",
        supplierName: "",
        manufacturerId: "",
        manufacturerName: "",
        zcgzId: "", // 资产故障
        zcgzName: "", // 资产故障
        jjcdId: "", // 紧急程度
        jjcdName: "", // 紧急程度
        QWXFTime: "",
        gzms: "",
        remark: "",
      };
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.form.details.map(
          (t) => (t.cardIds = t.assetCardIds.split(";").join(","))
        );
        let cardIds = this.form.details.map((t) => t.cardIds).join(",");
        let path = config.jmreportUrl + this.url + cardIds;
        SaveDeptAssetTransfer(this.form).then((res) => {
          if (this.showWorkFlowInfo) {
            this.$my_confirm(
              `资产卡片已更新！您也可以稍后在资产建卡模块中对单个资产卡片进行打印。<br><iframe frameborder="0" style="overflow: auto;height:280px;margin-top:10px" src='${path}'></iframe>`,
              "资产转科申请已提交，相关成员审核后 将自动转库！",
              {
                confirmButtonText: "继续创建",
                cancelButtonText: "返回列表",
                closeOnClickModal: false,
                type: "success",
              },
              "650px"
            )
              .then(() => {
                // 继续创建
                sessionStorage.setItem("editMode", 1);
                this.InitData();
              })
              .catch(() => {
                // 返回列表
                sessionStorage.setItem("editMode", 0);
                this.$router.push({ path: this.getMainPath(this.$route.path) });
              });
          } else {
            this.$my_confirm(
              `资产卡片已更新！您也可以稍后在资产建卡模块中对单个资产卡片进行打印。<br><iframe style="overflow: auto;height:280px;margin-top:10px" src='${path}'></iframe>`,
              "资产转科已成功！",
              {
                confirmButtonText: "继续创建",
                cancelButtonText: "返回列表",
                closeOnClickModal: false,
                type: "success",
              },
              "650px"
            )
              .then(() => {
                // 继续创建
                sessionStorage.setItem("editMode", 1);
                this.InitData();
              })
              .catch(() => {
                // 返回列表
                sessionStorage.setItem("editMode", 0);
                this.$router.push({ path: this.getMainPath(this.$route.path) });
              });
          }
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    /**
     * 获取资产编号
     */
    getFixedAssetList (keyWord) {
      this.GetStocksContainDetailByQuery({
        keyWord: keyWord,
        deptId: this.form.oldDeptId ? this.form.oldDeptId : "-1",
      });
    },
    /**
     * 获取资产卡号
     */
    getAssetCards (keyWord) {
      this.getAssetCardsByQuery({
        keyWord: keyWord,
        // stockDetailId: this.childForm.stockDetailId
        //   ? this.childForm.stockDetailId
        //   : "-1",
        category: "1",
        // states: [0, 1],
        // deptId: this.form.oldDeptId ? this.form.oldDeptId : "-1",
      }).then((res) => {
        if (this.form.assetCardInfos && this.form.assetCardInfos.length > 0) {
          this.form.assetCardInfos.forEach((item) => {
            let o = this.STATIC_AssetCards.find((e) => e.id == item.id);
            if (!o) {
              this.STATIC_AssetCards.push(item);
            }
          });
        }
      });
    },
    /**
     * 新科室选择
     */
    newDeptChange (val) {
      this.form.newDeptId = val;
      this.getDeptUsers(val, "").then((res) => {
        this.newDeptUsers = res;
        let item = this.STATIC_Depts.find((e) => e.id == val);
        if (item) {
          var user = this.newDeptUsers.find((e) => e.id == item.leader);
          if (user) {
            this.form.newUserId = item.leader;
            this.form.newUserName = item.leaderName;
          } else {
            this.$set(this.form, "newUserId", "");
            this.$set(this.form, "newUserName", "");
          }
        } else {
          this.$set(this.form, "newUserId", "");
          this.$set(this.form, "newUserName", "");
        }
      });
      this.getnewCustodianUsers();
    },
    /**
     * 原科室选择
     */
    oldDeptChange (val) {
      this.form.oldDeptId = val;
      this.getDeptUsers(val, "").then((res) => {
        this.oldDeptUsers = res;
        let item = this.STATIC_Depts.find((e) => e.id == val);
        if (item) {
          var user = this.oldDeptUsers.find((e) => e.id == item.leader);
          if (user) {
            this.form.oldUserId = item.leader;
            this.form.oldUserName = item.leaderName;
          } else {
            this.$set(this.form, "oldUserId", "");
            this.$set(this.form, "oldUserName", "");
          }
        } else {
          this.$set(this.form, "oldUserId", "");
          this.$set(this.form, "oldUserName", "");
        }
      });
      this.getCustodianUsers();
      this.getFixedAssetList();
    },
    getOldDeptUsers (keyword) {
      this.getDeptUsers(
        this.form.oldDeptId ? this.form.oldDeptId : "-1",
        keyword
      ).then((res) => {
        this.oldDeptUsers = res;
      });
    },
    /**
     * 原使用人选择
     */
    oldUserChange (val) {
      this.form.oldUserId = val;
    },
    /**
     * 原保管人
     */
    getCustodianUsers (keyword) {
      this.getDeptUsers(
        this.form.oldDeptId ? this.form.oldDeptId : "-1",
        keyword
      ).then((res) => {
        this.custodianUsers = res;
      });
    },
    /**
     * 原科室保管人选中
     */
    custodianChange (val) {
      this.form.custodianId = val;
    },
    getNewDeptUsers (keyword) {
      this.getDeptUsers(
        this.form.newDeptId ? this.form.newDeptId : "-1",
        keyword
      ).then((res) => {
        this.newDeptUsers = res;
      });
    },
    /**
     * 新使用人选择
     */
    newUserChange (val) {
      this.form.newUserId = val;
    },
    /**
     * 新保管人
     */
    getnewCustodianUsers (keyword) {
      this.getDeptUsers(
        this.form.newDeptId ? this.form.newDeptId : "-1",
        keyword
      ).then((res) => {
        this.newCustodianUsers = res;
      });
    },
    /**
     * 新保管人选中
     */
    newCustodianChange (val) {
      this.form.newCustodianId = val;
    },
    /**
     * 资产编号选择
     */
    selectAsset (row) {
      this.childForm = Object.assign(this.childForm, row, {
        // fixedAssetNo: row.no,
        // fixedAssetName: row.name,
        id: 0,
        number: 1,
        stockState: row.state,
      });
      this.getAssetCards("");
    },
    /**
     * 资产卡号选择
     */
    cardChange (val) {
      if (val && val.length > 0) {
        this.childForm.assetCardIds = val.join(";");
        this.childForm.cardIds = val.join(",");
        let isAdd = false;
        // 判断是新增还是删除
        for (let i = 0; i < val.length; i++) {
          if (!this.childForm.assetCardInfos) {
            this.childForm.assetCardInfos = [];
          }
          let item = this.childForm.assetCardInfos.find((e) => e.id == val[i]);
          if (item == null) {
            isAdd = true;
            let obj = this.STATIC_AssetCards.find((e) => e.id == val[i]);
            if (obj) {
              this.childForm.assetCardInfos.push(obj);
            }
            break;
          }
        }

        // 删除
        if (!isAdd) {
          this.childForm.assetCardInfos = this.childForm.assetCardInfos.filter(
            (i) => val.indexOf(i.id) != -1
          );
        }
      } else {
        this.childForm.assetCardIds = "";
        this.childForm.assetCardInfos = [];
      }
      this.childForm.maxNum = this.childForm.assetCardInfos.length;
      this.childForm.number = this.childForm.assetCardInfos.length;
    },
    childNumberChange () {
      if (this.childForm.maxAmount) {
        if (this.childForm.number > this.childForm.maxAmount) {
          this.childForm.number = this.childForm.maxAmount;
        }
      }
      this.autoAmount();
      this.childForm.notReceivedNumber = this.childForm.number;
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(2) * 1;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber;
      this.form.totalAmount = totalAmount;
    },
    /**
     * 明细表添加
     */
    handleAddChildForm () {
      if (!this.form.details) {
        this.form.details = [];
      }
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
    },

    /**
     * 明细表删除
     */
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
      this.autoTotalAmount();
    },
    /**
     * 子表选中行
     */
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    /**
     * 子表双击
     */
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.$set(
        this.childForm,
        "assetCardIdArr",
        this.childForm.assetCardInfos?.map((e) => e.id)
      );
      this.getAssetCards("");
    },
    /**
     * 关闭子弹窗
     */
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    /**
     * 继续添加
     */
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
    },
    /**
     * 子弹框提交
     */
    submitChildForm () {
      this.pushChildForm(true);
    },
    /**
     * 保存
     */
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
            e.assetId == this.childForm.assetId &&
            e.price == this.childForm.price &&
            e.locationName == this.childForm.locationName &&
            e.assetSource == this.childForm.assetSource &&
            e.packDesc == this.childForm.packDesc &&
            e.manufacturerId == this.childForm.manufacturerId &&
            e.certId == this.childForm.certId &&
            e.brandId == this.childForm.brandId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前退库信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.InitData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () { },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped></style>
